import React, {useCallback, useEffect, useState, useRef} from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  Dimensions,
  ScrollView,
} from 'react-native';
import {RefreshControl} from 'react-native-web-refresh-control';
import {Color, globalFontStyle} from '../../assets';
import Header from '../../commonComponents/Header';
import {useSelector, useDispatch, connect} from 'react-redux';
import SubCategories from '../home/childComponents/subCategories';
import TradeCard from '../home/childComponents/tradeCard';
import {
  fetchHashTagProbesRequest,
  removeProbe,
} from '../home/redux/home.action';
import {getEventDetails} from '../event/redux/events.actions';
import RenderHtml from 'react-native-render-html';
import {
  atob,
  buildLinkHashTag,
  checkColums,
  isMobile,
  timeLagFromCurrentTime,
} from '../../utils/commonMethods';
import RenderHtmlScore from './renderHtml';
import {useFocusEffect} from '@react-navigation/native';
import Colors from '../../assets/Color/Colors';
import {SafeAreaView, useSafeAreaInsets} from 'react-native-safe-area-context';
import Width from '../../assets/Width';
import {globalImport} from '../../common/globalImports';
import MultiCard from '../home/childComponents/multiCard';
import {getCurrentRoute} from '../../navigation/rootNavigation';
import {
  hideLoader,
  showLoader,
} from '../../commonComponents/Loader/loader.actions';
import ParentProbeCard from '../home/childComponents/parentProbeCard';
import YoutubePlayerReact from '../home/childComponents/youtubePlayerReact';
import LiveView from '../../commonComponents/LiveView';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../utils/globalConstant';
import ShareHashtag from './ShareHashtag';
import { useToast } from '../../components/core/Toast';

const HashTag = ({navigation, route, wsConnected, ws}) => {
  let hash_tag = route.params?.hash_tag;
  const insets = useSafeAreaInsets();
  const [mulitOptionList, setMultiOptionList] = useState([]);
  //const mulitOptionList = hash_tag?.mulitOptionList;
  const column = checkColums();
  const selectedSubCategory = route.params?.selectedSubCategory;
  const dispatch = useDispatch();
  const probeData = useSelector(({probesReducer}) => probesReducer?.hashData);
  const loading = useSelector(({probesReducer}) => probesReducer?.hashLoading);
  const [FilteredProbe, setFilteredProbe] = useState([]);
  const eventDetails = useSelector(
    ({eventReducer}) => eventReducer?.eventDetails,
  );
  const [filteredProbeList, setFilteredProbeList] = useState([]);
  const hashTagFlatList = useRef();

  const [subCatList, setSubCatList] = useState(['All']);
  const [selectedCat, setSelectedCat] = useState('All');
  const [liveStatsId, setLiveStatsId] = useState();

  const [liveDataNew, setLiveDataNew] = useState(null);

  const [playing, setPlaying] = useState(true);

  const { toast } = useToast();

  const onStateChange = useCallback((state) => {
    if (state === "ended") {
      setPlaying(false);
    }
  }, []);

  useEffect(() => {
    // if (!probeData?.probes?.length) {
    dispatch(fetchHashTagProbesRequest({sortingType: 0, hashtags: hash_tag}));
    // }
  }, []);

  useEffect(() => {
    //let tempList = ["All"];
    let id = null;
    let date = Date.now();
    const multiOptionFilter = {};

    const filteredProbes = probeData?.probes?.filter(probe => {
      if (!(probe.parent_id < 1)) {
        if (
          multiOptionFilter.length > 0 &&
          multiOptionFilter[probe.parent_id]?.length > 0
        ) {
          if (multiOptionFilter[probe.parent_id]?.length < 2)
            multiOptionFilter[probe.parent_id].push(probe);
        } else {
          multiOptionFilter[probe.parent_id] = [probe];
        }
      }

      //const isHashTagExist = probe?.hashtags?.includes(hash_tag);
      const isSameSubCat = !selectedSubCategory
        ? true
        : probe?.subcategory === selectedSubCategory;
      if (isSameSubCat) {
        if (Date.parse(probe.endsat) > date) {
          date = Date.parse(probe.endsat);
          id = probe.id;
        }
        // const tempData = probe.subsubcat;
        // if (tempData && Array.isArray(tempData)) {
        //   tempData.forEach(data => {
        //     if (!tempList.includes(data)) {
        //       tempList.push(data);
        //     }
        //   });
        // }
      }

      return isSameSubCat;
    });

    //console.log(filteredProbes);
    setMultiOptionList(multiOptionFilter);
    setFilteredProbeList(filteredProbes);
    setLiveStatsId(id);
    if (probeData?.subsubcatArr) {
      setSubCatList(probeData?.subsubcatArr);
      setSelectedCat(probeData?.subsubcatArr[0]);
    }
  }, [probeData]);

  useEffect(() => {
    if (filteredProbeList?.length > 0 && selectedCat) {
      const filteredProbeList1 = filteredProbeList.filter(item => {
        if (item.parent_id < 1) {
          if (selectedCat === null || selectedCat === 'All') {
            return true;
          } else if (item.subsubcat && item.subsubcat.includes(selectedCat)) {
            return true;
          } else {
            return false;
          }
        }
      });

      setFilteredProbe(filteredProbeList1);
    }
  }, [selectedCat, filteredProbeList]);

  useFocusEffect(
      React.useCallback(() => {
        setLiveDataNew(eventDetails?.liveCard?.text
            ? atob(eventDetails?.liveCard?.text)
            : null);

        return () => {
          setLiveDataNew(null);
        };
      }, [eventDetails]),
  );

  useFocusEffect(
    React.useCallback(() => {
      if (wsConnected === 1 && ws && liveStatsId) {
        try {
          ws.send(
            JSON.stringify({
              topic: `probe-detail_${liveStatsId}`,
              action: 'subscribe',
            }),
          );
        } catch (e) {}
      }

      return () => {
        if (wsConnected === 1 && ws) {
          try {
            ws.send(
              JSON.stringify({
                topic: `probe-detail_${liveStatsId}`,
                action: 'unsubscribe',
              }),
            );
          } catch (e) {}
        }
      };
    }, [liveStatsId, wsConnected, ws]),
  );

  useFocusEffect(
    React.useCallback(() => {
      if (liveStatsId) {
        if (getCurrentRoute() === 'HashTag') {
          getData(liveStatsId);
        }
      }
    }, [liveStatsId]),
  );

  const getData = async liveStatsId => {
    dispatch(showLoader());
    await dispatch(getEventDetails(liveStatsId));
    dispatch(hideLoader());
  };

  function handleClickOnSubSubCategories(c) {
    if (c === selectedCat) {
      setSelectedCat(null);
    } else {
      setSelectedCat(c);
    }
    /*if (hashTagFlatList?.current) {
      hashTagFlatList?.current?.scrollToIndex({
        animated: true,
        index: 0,
      });
    }*/
  }

  const onCardClick = item => {
    if (Date.parse(item?.endsat) < Date.now()) {
      dispatch(removeProbe(item?.id, true));
      toast({
        title: 'This event is no longer active',
        variant: 'destructive'
      });
    } else {
      navigation.navigate('Event', {
        eventId: item.id,
        isMulti: item.parent_id === -1 ? true : false,
      });
    }
  };

  const timerExpireCallback = item => {
    if (Date.parse(item?.endsat) < Date.now()) {
      dispatch(removeProbe(item?.id, true));
    }
  };
  const renderProbeCard = ({item, index}) => {
    if (item.empty) {
      return <View style={!isMobile() ? {flex: 1} : {flex: 1}} />;
    }

    // Base styles for both card types
    const cardStyles = [
      {flex: 1},
      !isMobile() && {
        boxSizing: 'border-box',
        maxWidth: `${100 / column}%`,
        paddingLeft: index % column === 0 ? 0 : 16,
        paddingRight: index % column === column - 1 ? 0 : 16,
        borderLeft: index % column !== 0 ? '1px solid rgba(0, 0, 0, 0.04)' : 'none',
      },
    ];

    // Add padding and borders only for trade cards
    if (!item?.events && !isMobile()) {
      cardStyles.push({
        paddingTop: index < column ? 0 : 32,
        paddingBottom: 32,
        ...(index >= column && {borderTop: '1px solid rgba(0, 0, 0, 0.04)'}),
      });
    }

    const containerStyles = [{flex: 1}];

    // Add mobile-specific styles
    if (isMobile()) {
      containerStyles.push({
        marginHorizontal: 16,
        ...(!item?.events && {
          paddingBottom: 18,
          paddingTop: index === 0 ? 0 : 18,
          borderBottom: '1px solid rgba(0, 0, 0, 0.04)',
        }),
      });
    }

    return (
      <View style={cardStyles}>
        <TouchableOpacity style={containerStyles} onPress={() => onCardClick(item)}>
          {item?.parent_id === -1 ? (
            <MultiCard
              trade={item}
              mulitOptionList={mulitOptionList[item.id]}
              onCallback={() => {
                onCardClick(item);
              }}
              timerExpireCallback={timerExpireCallback}
              liveStatsId={liveStatsId}
            />
          ) : (
            <ParentProbeCard trade={item} />
          )}
        </TouchableOpacity>
      </View>
    );
  };
  const formatData = data => {
    if (globalImport.isWeb) {
      const numColumns = checkColums();
      const amountFullRows = Math.floor(data.length / numColumns);
      let amountItemsLastRow = data.length - amountFullRows * numColumns;

      while (amountItemsLastRow !== numColumns && amountItemsLastRow !== 0) {
        data.push({key: `empty-${amountItemsLastRow}`, empty: true});
        amountItemsLastRow++;
      }
    }

    return data;
  };

  const PullToRefresh = () => {
    dispatch(fetchHashTagProbesRequest({sortingType: 0, hashtags: hash_tag}));
  };
  const htmlContent = `
    <h1>This HTML snippet is now rendered with native components !</h1>
    <h2>Enjoy a webview-free and blazing fast application</h2>
   
    <em style="textAlign: center;">Look at how happy this native cat is</em>
`;

  const shareHashTag = () => {
    dispatch(showLoader());
    buildLinkHashTag(hash_tag?.substring(1), selectedSubCategory, () => {
      dispatch(hideLoader());
    });
  };

  const child = <ShareHashtag hashtag={hash_tag} />;

  const renderYoutubePlayer = () => {
    if (hash_tag === '#DelhiElections') {
      return (
        <View style={styles.youtubeContainer}>
          <YoutubePlayerReact
            hTTVideoKey={globalImport.isWeb ? 'https://www.youtube.com/watch?v=sYZtOFzM78M' : 'sYZtOFzM78M'}
            onStateChange={onStateChange}
            isHashtag={true}
          />
        </View>
      );
    }
    return null;
  };

  return (
    <SafeAreaView style={[styles.container, isMobile() && styles.mobileContainer]}>
      {isMobile() ? (
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName={hash_tag}
          backGroundColor={globalConfigurableData.headerColor}
          isCheckGoBack={true}
          shareMethod={shareHashTag}
          children={child}
        />
      ) : (
        <Header selected={'Markets'} />
      )}
      <View style={{flex: 1}}>
        <FlatList
          contentContainerStyle={[
            {
              paddingBottom: globalImport.isWeb ? 0 : 120,
              paddingHorizontal: isMobile() ? 0 : Math.max(insets.left, 16),
            },
            !isMobile() ? styles.dekstopHomeCards : {},
          ]}
          numColumns={isMobile() ? 1 : column}
          ref={hashTagFlatList}
          ListHeaderComponent={
            <>
              {(renderYoutubePlayer() || liveDataNew || eventDetails?.liveView) && (
                <View
                  style={[
                    {paddingHorizontal: isMobile() ? 16 : 0},
                    isMobile() && styles.mobileHeader,
                  ]}>
                  {renderYoutubePlayer()}
                  {liveDataNew ? (
                    <>
                      <View style={styles.liveDataContainer}>
                        <RenderHtmlScore liveDataNew={liveDataNew} />
                      </View>
                      <View style={styles.lastUpdatedContainer}>
                        <Text
                          style={[
                            globalFontStyle.appFontSmallText,
                            styles.lastUpdatedLabel,
                          ]}>
                          Last Updated
                        </Text>
                        <Text
                          style={[
                            globalFontStyle.appFontSmallText,
                            styles.lastUpdatedTime,
                          ]}>
                          {timeLagFromCurrentTime(eventDetails?.liveCard?.time)}
                        </Text>
                      </View>
                    </>
                  ) : eventDetails?.liveView && isMobile() ? (
                    <LiveView videoKey={eventDetails?.liveView} />
                  ) : null}
                </View>
              )}
              {subCatList?.length > 1 && (
                <View style={[
                  styles.subCategoriesContainer,
                  {paddingHorizontal: isMobile() ? 16 : 0}
                ]}>
                  <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                  >
                    <SubCategories
                      subCategory={subCatList}
                      onSubCategoryUpdate={handleClickOnSubSubCategories}
                      selectedSubCategory={selectedCat}
                    />
                  </ScrollView>
                </View>
              )}
            </>
          }
          ListFooterComponent={
            !isMobile() && eventDetails?.liveView && !liveDataNew ? (
              <View style={styles.desktopLiveViewContainer}>
                <LiveView videoKey={eventDetails?.liveView} isHashtag={true} />
              </View>
            ) : null
          }
          scrollEnabled={FilteredProbe?.length === 0 ? true : true}
          data={formatData(FilteredProbe) || [{empty: true}]}
          renderItem={renderProbeCard}
          keyExtractor={(item, index) => item.id + ''}
          showsVerticalScrollIndicator={false}
          initialNumToRender={10}
          updateCellsBatchingPeriod={15}
          refreshControl={
            <RefreshControl refreshing={loading} onRefresh={PullToRefresh} />
          }
        />
      </View>
    </SafeAreaView>
  );
};

const mapStateToProps = store => ({
  wsConnected: store?.liveReducer?.connected,
  ws: store?.liveReducer?.wsRef,
  //appIdle: store?.utilCommonData?.appIdle,
});

export default connect(mapStateToProps, null)(HashTag);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: globalConfigurableData.backgroundColor,
  },
  mobileContainer: {
    paddingTop: 0,
  },
  mobileHeader: {
    marginBottom: 8,
  },
  dekstopHomeCards: {
    //justifyContent: "center",
    //flexDirection: "row",
    //flexWrap: "wrap",
  },
  liveDataContainer: {
    marginTop: 15,
    borderWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    borderRadius: 8,
    backgroundColor: GlobalScreens.Event.StatsBlock,
  },
  lastUpdatedContainer: {
    flexDirection: 'row',
    paddingTop: 10,
  },
  lastUpdatedLabel: {
    color: globalConfigurableData.secondaryTextColor1,
    marginRight: 5,
  },
  lastUpdatedTime: {
    color: Color.grey,
    marginRight: 5,
  },
  subCategoriesContainer: {
    marginVertical: 20,
    overflow: 'hidden',
  },
  desktopLiveViewContainer: {
    flex: 1,
    paddingTop: 71,
    paddingLeft: 20,
  },
  youtubeContainer: {
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: GlobalScreens.Event.StatsBlock,
  },
});
